import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  t: "1724721510604",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "1551",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M617.792 807.424H173.44c-51.328 0-93.056-45.248-93.056-100.928V384.256c0-55.68 41.728-100.992 93.056-100.992h444.352c51.328 0 93.056 45.312 93.056 100.992v322.24c0 55.68-41.728 100.928-93.056 100.928zM173.44 331.328c-24.832 0-45.056 23.744-45.056 52.992v322.24c0 29.184 20.16 52.928 45.056 52.928h444.352c24.896 0 45.056-23.744 45.056-52.928V384.256c0-29.248-20.16-52.992-45.056-52.992H173.44z",
      "p-id": "1552",
      fill: "#ffffff"
    }, null, -1),
    _createElementVNode("path", {
      d: "M907.328 779.776a48.192 48.192 0 0 1-25.344-7.808L664.256 636.8l25.344-40.768 208.064 129.216 0.128-359.68-208.192 129.216-25.344-40.768 217.664-135.232c14.848-9.152 30.656-10.24 43.584-3.136 12.864 7.168 20.288 21.312 20.288 38.656v382.144c0 17.344-7.36 31.424-20.288 38.656a37.824 37.824 0 0 1-18.176 4.672z",
      "p-id": "1553",
      fill: "#ffffff"
    }, null, -1),
    _createElementVNode("path", {
      d: "M214.528 416.512m-33.024 0a33.024 33.024 0 1 0 66.048 0 33.024 33.024 0 1 0-66.048 0Z",
      "p-id": "1554",
      fill: "#ffffff"
    }, null, -1)
  ]))]))
}
export default { render: render }